export default {
  uiv: {
    datePicker: {
      clear: 'Wyczyść',
      today: 'Dzisiaj',
      month: 'Miesiąc',
      month1: 'Styczeń',
      month2: 'Luty',
      month3: 'Marzec',
      month4: 'Kwiecień',
      month5: 'Maj',
      month6: 'Czerwiec',
      month7: 'Lipiec',
      month8: 'Sierpień',
      month9: 'Wrzesień',
      month10: 'Październik',
      month11: 'Listopad',
      month12: 'Grudzień',
      year: 'Rok',
      week1: 'Pon',
      week2: 'Wt',
      week3: 'Śr',
      week4: 'Czw',
      week5: 'Pt',
      week6: 'So',
      week7: 'Nie',
    },
    timePicker: {
      am: 'AM',
      pm: 'PM',
    },
    modal: {
      cancel: 'Anuluj',
      ok: 'OK',
    },
    multiSelect: {
      placeholder: 'Wybierz...',
      filterPlaceholder: 'Szukaj...',
    },
  },
};
